import { buildService } from './decorated-service';
import settings from '../../../settings.json';

const api = buildService('/nasu-svc/service');

export const mockOCRBeneficiaries = {
  individualInvestorBeneficiaries: {
    individuals: [
      {
        taxID: '111111111',
        percentage: 1,
        beneficiaryType: 'PRIMARY',
        name: {
          firstName: 'First',
          middleName: '',
          lastName: 'Name',
          suffix: ''
        },
        dateOfBirthString: '01/01/1985',
        relationship: 'SPOUSE'
      },
      {
        taxID: '222222222',
        percentage: 25,
        beneficiaryType: 'PRIMARY',
        name: {
          firstName: 'Second',
          middleName: '',
          lastName: 'Name',
          suffix: ''
        },
        dateOfBirthString: '01/01/2012',
        relationship: 'CHILD'
      },
      {
        taxID: '333333333',
        percentage: 40,
        beneficiaryType: 'PRIMARY',
        name: {
          firstName: 'Third',
          middleName: '',
          lastName: 'Name',
          suffix: ''
        },
        dateOfBirthString: '01/01/2016',
        relationship: 'CHILD'
      },
      {
        taxID: '444444444',
        percentage: 10,
        beneficiaryType: 'SECONDARY',
        name: {
          firstName: 'Fourth',
          middleName: '',
          lastName: 'Name',
          suffix: ''
        },
        dateOfBirthString: '01/01/2019',
        relationship: 'CHILD'
      },
      {
        taxID: '555555555',
        percentage: 15,
        beneficiaryType: 'SECONDARY',
        name: {
          firstName: 'Fifth',
          middleName: '',
          lastName: 'Name',
          suffix: ''
        },
        dateOfBirthString: '01/01/2020',
        relationship: 'CHILD'
      }
    ],
    entities: [
      {
        taxID: '666666666',
        percentage: 10,
        beneficiaryType: 'PRIMARY',
        name: 'Primary Entity'
      },
      {
        taxID: '777777777',
        percentage: 0,
        beneficiaryType: 'UNAVAILABLE',
        name: 'Secondary Entity'
      },
      {
        taxID: '888888888',
        percentage: 20,
        beneficiaryType: 'SECONDARY',
        name: 'Third Entity'
      },
      {
        taxID: '999999999',
        percentage: 0,
        beneficiaryType: 'UNAVAILABLE',
        name: 'Fourth Entity'
      }
    ]
  },
  retirementBeneficiaries: {
    individuals: [
      {
        taxID: '111111111',
        percentage: 0,
        beneficiaryType: 'PRIMARY',
        name: {
          firstName: 'Primary',
          middleName: '',
          lastName: 'First',
          suffix: ''
        },
        dateOfBirthString: '01/01/1985',
        relationship: 'SPOUSE'
      },
      {
        taxID: '222222222',
        percentage: 0,
        beneficiaryType: 'PRIMARY',
        name: {
          firstName: 'Primary',
          middleName: '',
          lastName: 'Second',
          suffix: ''
        },
        dateOfBirthString: '01/01/2012',
        relationship: 'CHILD'
      },
      {
        taxID: '333333333',
        percentage: 0,
        beneficiaryType: 'SECONDARY',
        name: {
          firstName: 'Secondary',
          middleName: '',
          lastName: 'First',
          suffix: ''
        },
        dateOfBirthString: '01/01/2016',
        relationship: 'CHILD'
      },
      {
        taxID: '444444444',
        percentage: 0,
        beneficiaryType: 'SECONDARY',
        name: {
          firstName: 'Secondary',
          middleName: '',
          lastName: 'Second',
          suffix: ''
        },
        dateOfBirthString: '01/01/2019',
        relationship: 'CHILD'
      }
    ],
    entities: [
      {
        taxID: '555555555',
        percentage: 0,
        beneficiaryType: 'PRIMARY',
        name: 'Primary Entity'
      },
      {
        taxID: '666666666',
        percentage: 0,
        beneficiaryType: 'SECONDARY',
        name: 'Secondary Entity'
      }
    ]
  }
};

export const getRPSExistingBeneficiaries = async (
  businessPartyId: number | undefined,
  ssn: string | undefined,
  rpsChosenPlan: string | undefined,
  agreementType: string | undefined
): Promise<any> => {
  if (settings['mockedMode']) return mockOCRBeneficiaries;
  const errorCodes = [204, 404, 403, 500];

  return api.http.post(
    '/v2/beneficiaries',
    {
      customerID: {
        individualInvestorCustomerID: {
          businessPartyId
        },
        retirementCustomerID: {
          ssn,
          planNumber: rpsChosenPlan
        }
      },
      agreementType
    },
    { errorCodes, ignoreServiceFailure: true }
  );
};

export default api;
